export const XSRF_TOKEN = {
    cookieName: 'xsrf-token',
    headerName: 'x-xsrf-token'
}